import { render, staticRenderFns } from "./ProductDiscountSuppliersPrintReport.vue?vue&type=template&id=101fcab4&scoped=true&"
import script from "./ProductDiscountSuppliersPrintReport.vue?vue&type=script&lang=js&"
export * from "./ProductDiscountSuppliersPrintReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscountSuppliersPrintReport.vue?vue&type=style&index=0&id=101fcab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101fcab4",
  null
  
)

export default component.exports